export default "__VITE_ASSET__BtccxmSA__"